<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9816 13.2663C20.9816 12.9045 21.104 12.5427 21.104 12.0603C21.104 11.5779 21.104 11.2161 20.9816 10.8543L23.5523 8.804C23.7972 8.5628 23.7972 8.32159 23.6748 8.08039L21.2264 3.85929C21.104 3.73869 20.8592 3.61808 20.4919 3.73869L17.4314 4.94471C16.8193 4.4623 16.0848 4.10049 15.3503 3.73869L14.8607 0.603014C14.9831 0.241206 14.6158 0 14.371 0H9.47426C9.22938 0 8.86217 0.241206 8.86217 0.482411L8.3725 3.73869C7.63799 3.97989 7.0259 4.4623 6.29139 4.94471L3.35336 3.73869C2.98611 3.61808 2.74127 3.73869 2.49639 3.97989L0.0480252 8.20099C-0.0743928 8.32159 0.0480252 8.6834 0.292861 8.92461L2.86364 10.8543C2.86364 11.2161 2.74122 11.5779 2.74122 12.0603C2.74122 12.5427 2.74122 12.9045 2.86364 13.2663L0.292861 15.3166C0.0480252 15.5578 0.0480252 15.799 0.170443 16.0402L2.6188 20.2613C2.74122 20.3819 2.98601 20.5025 3.35331 20.3819L6.41376 19.1759C7.02585 19.6583 7.76036 20.0201 8.49487 20.3819L8.98454 23.5176C8.98454 23.7588 9.22938 24 9.59663 24H14.4934C14.7382 24 15.1054 23.7587 15.1054 23.5176L15.5951 20.3819C16.3296 20.0201 17.0641 19.6583 17.6762 19.1759L20.7367 20.3819C20.9816 20.5025 21.3488 20.3819 21.4712 20.1407L23.9196 15.9196C24.042 15.6784 24.042 15.3166 23.7971 15.196L20.9816 13.2663ZM11.9226 16.2814C9.59668 16.2814 7.63799 14.3517 7.63799 12.0603C7.63799 9.76883 9.59668 7.83918 11.9226 7.83918C14.2486 7.83918 16.2073 9.76883 16.2073 12.0603C16.2073 14.3517 14.2486 16.2814 11.9226 16.2814Z"
    />
  </svg>
</template>

<script>
import { colors } from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: colors.iconColor },
  },
  name: "IconChoiseChat",
};
</script>


<style scoped>
  path{
    fill: var(--icon-path);
  }
</style>